import { render, staticRenderFns } from "./equipmentDesc.vue?vue&type=template&id=e4646c7c&scoped=true"
import script from "./equipmentDesc.vue?vue&type=script&lang=js"
export * from "./equipmentDesc.vue?vue&type=script&lang=js"
import style0 from "./equipmentDesc.vue?vue&type=style&index=0&id=e4646c7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4646c7c",
  null
  
)

export default component.exports